import { Tooltip } from 'antd'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'

const StatusTooltip = ({
  label,
  children
}: {
  label: string
  children: React.ReactNode
}) => (
  <Tooltip
    title={<TooltipText>{label}</TooltipText>}
    overlayInnerStyle={{
      backgroundColor: '#000',
      borderRadius: '9px',
      padding: '8px 12px'
    }}
    color="#000"
  >
    {children}
  </Tooltip>
)

export default StatusTooltip

const TooltipText = styled(Text)`
  color: #fff;
  font-weight: 400;
`
